import { createSelector } from 'reselect';

const selectDBADiscountMappings = (state: any) => state.dbaDiscountMappings;

export const selectDBADiscountMappingsCurrentItem = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.current);

export const selectDBADiscountMappingsListItems = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.list);

export const selectDBADiscountMappingsItemById = (itemId: any) =>
    createSelector(selectDBADiscountMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDBADiscountMappingsQueryItems = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.query);

export const selectDBADiscountMappingsCreatedItem = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.create);

export const selectDBADiscountMappingsUpdatedItem = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.update);

export const selectDBADiscountMappingsReadItem = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.read);

export const selectDBADiscountMappingsDeletedItem = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.delete);

export const selectDBADiscountMappingsPublishedItem = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.publish);

export const selectDBADiscountMappingsSearchedItems = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.search);

export const selectDBADiscountMappingsItemsCount = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.count);

export const selectDBADiscountMappingsItemsFilter = createSelector([selectDBADiscountMappings], (dbaDiscountMappings) => dbaDiscountMappings.filter);